"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenInNew = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var OpenInNew = function OpenInNew() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 21.333V14a.667.667 0 00-.667-.667H22a.667.667 0 00-.667.667v7.333H2.667V2.667H10A.667.667 0 0010.667 2V.667A.667.667 0 0010 0H2.667A2.667 2.667 0 000 2.667v18.666A2.667 2.667 0 002.667 24h18.666A2.667 2.667 0 0024 21.333zM23.347.307l.36.36V.653a1 1 0 01.293.68V10a.667.667 0 01-.667.667H22a.667.667 0 01-.667-.667V4.56L10.08 15.8a.667.667 0 01-.947 0l-.933-.933a.667.667 0 010-.947L19.453 2.667H14A.667.667 0 0113.333 2V.667c0-.369.299-.667.667-.667h8.667a1 1 0 01.68.307z",
    clipRule: "evenodd"
  });
};

exports.OpenInNew = OpenInNew;